import {
  IWixStyleColor,
  IWixStyleFont,
} from 'yoshi-flow-editor-runtime/tpa-settings';

import { DataHook } from './data-hook';
import { InjectedGlobalSettings } from './props';
import {
  BadgeLayout as BadgeLayoutEnum,
  BadgeSize as BadgeSizeEnum,
  ProfileLayout as ProfileLayoutEnum,
  ProfileImage,
} from './widget';

export enum NumberStyleParam {
  BadgeLayout = 'badge-layout',
  BadgeSize = 'badge-size',
  BadgeCornerRadius = 'badge-corner-radius',
  ProfileLayout = 'profileLayout',
  PictureStyle = 'pictureStyle',
}

export enum ColorStyleParam {
  ButtonColor = 'button-opacity-and-color',
}

export enum FontStyleParam {
  BadgeFont = 'badge-font',
}

export enum BooleanStyleParam {
  ShowBadgeBackground = 'show-badge-background',
  ShowCover = 'showCover',
  ShowMessageButton = 'showMessageButton',
  ShowMessageButtonMobile = 'showMessageButtonMobile',
}

export interface NumberStyleParamMap {
  [NumberStyleParam.BadgeLayout]?: BadgeLayoutEnum;
  [NumberStyleParam.BadgeSize]?: BadgeSizeEnum;
  [NumberStyleParam.BadgeCornerRadius]?: number;
  [NumberStyleParam.ProfileLayout]?: ProfileLayoutEnum;
  [NumberStyleParam.PictureStyle]?: ProfileImage;
}

export type ColorStyleParamMap = { [key in ColorStyleParam]?: IWixStyleColor };

export type BooleanStyleParamMap = { [key in BooleanStyleParam]?: boolean };

export type FontStyleParamMap = { [key in FontStyleParam]?: IWixStyleFont };

export interface SettingsEvent {
  tabChange: DataHook;
  globalSettings: Partial<InjectedGlobalSettings>;
}
